module.exports = __webpack_public_path__ + "static/media/logo.6d54e2c7.png";